import { useSuspenseQuery } from "@tanstack/react-query";
import { getPageSpeedSettings } from "../openapi/api-client.ts";
import { LoadPageSpeedSettingsError } from "../errors/LoadPageSpeedSettingsError.ts";

export const usePageSpeedSettings = (
  projectId?: string,
  appInstallationId?: string,
) =>
  useSuspenseQuery({
    queryKey: ["pageSpeedSettings", { projectId, appInstallationId }],
    queryFn: async () => {
      if (!projectId || !appInstallationId) {
        throw new Error("projectId and appInstallationId are required");
      }

      const response = await getPageSpeedSettings({
        path: { projectId, appInstallationId },
      });

      if (response.error) {
        throw new LoadPageSpeedSettingsError(
          response.error.message || `error while fetching pagespeed settings`,
        );
      }

      return response.data;
    },
  });
